const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/containers',
        component: Index
    },
    {
        path: '/new-container',
        component: CreatePage
    },
    {
        path: '/container/:id',
        component: ViewPage
    }
]